import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "underscore";
import hallImg from "../../assets/images/resume.png";
import { getCategoryList } from "../../store/shopping/shopping.selector";
import { fetchLiveStreamRequest } from "../../store/social/social.actions";
import { getLiveStreams } from "../../store/social/social.selector";
import { getImage, getUserProfile } from "../../store/user/user.selector";
import LiveStreamCard from "./liveStreamCard";

const MeetingRoom = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { userProfile, categories, allLiveStreams } = useSelector((state) => {
        return {
            userProfile: getUserProfile(state),
            categories: getCategoryList(state),
            allLiveStreams: getLiveStreams(state),
        };
    });

    useEffect(() => {
        if (categories.length > 0 && userProfile._id) {
            const cat = _.find(categories, (x) => x.name === "Meeting Room");
            dispatch(
                fetchLiveStreamRequest(
                    "?where=category:" + cat._id + ";owner:" + userProfile._id
                )
            );
        }
    }, [categories, userProfile]);

    let liveStreams = _.sortBy(allLiveStreams, (x) =>
        moment(x.dateUpdated).unix()
    ).reverse();

    let meetingRoom = liveStreams.map((item) => {
        let duration = "00 : 00 : 00";
        if (
            item.durationTime &&
            item.streamingStatus.toLowerCase() !== "waiting"
        ) {
            let ms = item.durationTime * 1000;
            var d = moment.duration(ms);
            duration = `${d._data.hours
                .toString()
                .padStart(2, "0")} : ${d._data.minutes
                    .toString()
                    .padStart(2, "0")} : ${d._data.seconds
                        .toString()
                        .padStart(2, "0")}`;
        }
        return {
            id: item._id,
            img: hallImg,
            title: item.title,
            watch: item.totalWatch,
            comment: item.comments,
            date: moment(item.dateCreated).fromNow(),
            duration: duration,
            users: {
                owner: {
                    name: item.owner.fullName,
                    userName: item.owner.userName,
                    image: getImage(item.owner.attachments),
                },
                guests: item.guestInfo.map((x) => {
                    return {
                        name: x.fullName,
                        image: getImage(x.attachments),
                    };
                }),
            },
            streamUrl: item.streamUrl,
            attachments: item.attachments,
            streamingStatus: item.streamingStatus,
            s3Url: item.s3Url,
        };
    });

    return (
        <div className="">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {meetingRoom.map((stream) => {
                    return <LiveStreamCard stream={stream}
                        canEdit={true}
                        canDelete={true} />;
                })}
            </div>
            {meetingRoom.length === 0 && (
                <div className="flex flex-col items-center justify-start pt-9">
                    <p className="text-sm text-black-50 mb-5">
                        You do not have any posts yet
                    </p>
                    <button
                        onClick={() => navigate("/page/start-new-video")}
                        className="py-2.5 px-[18px] bg-orange-color text-white text-sm font-bold rounded-lg"
                    >
                        Start New Live
                    </button>
                </div>
            )}
        </div>
    );
};

export default MeetingRoom;
